import { useApp, type Tab } from '../store';
import { AnalysisTab } from './AnalysisTab';
import { AreasTab } from './AreasTab';
import { EnergyTab } from './EnergyTab';
import { HistoryTab } from './HistoryTab';
import { LinksTab } from './LinksTab';

const TABS: [Tab, string][] = [
  ['areas', 'Jomas'],
  ['links', 'Saites'],
  ['energy', 'Enerģija'],
  ['analysis', 'Analīze'],
  ['history', 'Vēsture']
];

export function Panel() {
  const tab = useApp((s) => s.ui.tab);
  const setTab = useApp((s) => s.setTab);
  const nLinks = useApp((s) => s.wheel!.links.length);
  const nSnaps = useApp((s) => s.wheel!.snapshots.length);
  const cnt: Partial<Record<Tab, number>> = { links: nLinks, history: nSnaps };
  return (
    <section className="card panel" aria-label="Pārvaldība">
      <nav className="tabs" role="tablist">
        {TABS.map(([k, t]) => (
          <button key={k} type="button" role="tab" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={'tab-' + k}>
            {t}
            {cnt[k] ? <span className="cnt">{cnt[k]}</span> : null}
          </button>
        ))}
      </nav>
      <div className="tab" id={'tab-' + tab} role="tabpanel">
        {tab === 'areas' ? <AreasTab /> : null}
        {tab === 'links' ? <LinksTab /> : null}
        {tab === 'energy' ? <EnergyTab /> : null}
        {tab === 'analysis' ? <AnalysisTab /> : null}
        {tab === 'history' ? <HistoryTab /> : null}
      </div>
    </section>
  );
}
